import { render } from "./AboutCeoSection.vue?vue&type=template&id=008c7bba&scoped=true"
const script = {}

import "./AboutCeoSection.vue?vue&type=style&index=0&id=008c7bba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008c7bba"]])

export default __exports__